module.exports = __webpack_public_path__ + "img/collection-weddingRingsPolar.3b54f1c.jpg";